// extracted by mini-css-extract-plugin
export default {"logs__main":"logs_logs__main__3ZEnH","logs__div":"logs_logs__div__vf6ZM"};